import Stack from "@mui/material/Stack";
import { styled } from "../../../../../lib/styled";
import Typography from "@mui/material/Typography";
import { CodeBlock } from "../../../../../components/primitives/data-display/CodeBlock";
import { SectionLabel } from "../../../../../components/primitives/data-display/SectionLabel";
import { gaps } from "../../../../../components/primitives/spacing";
import { Panel } from "../../../../../components/primitives/surfaces/Panel";
import { PubmedQueryText } from "../../../../../components/domain/data-display/PubmedQueryText";

/** A long query scrolls inside its block, so it never pushes the rest of the page down. */
const QUERY_MAX_HEIGHT = 420;

function renderPubmedQuery(query: string) {
  return <PubmedQueryText query={query} />;
}

const FillStack = styled(Stack)({
  flex: 1,
  minHeight: 0,
});

interface FeedQueryProps {
  query: string;
}

/** A feed's PubMed query, readable and copyable. It cannot be changed. */
export function FeedQuery({ query }: FeedQueryProps) {
  return (
    <Panel fill>
      <FillStack gap={gaps.snug}>
        <SectionLabel>Query</SectionLabel>
        <CodeBlock code={query} renderCode={renderPubmedQuery} maxHeight={QUERY_MAX_HEIGHT} fill />
        <Typography variant="caption" color="text.secondary">
          Fixed when the feed was created.
        </Typography>
      </FillStack>
    </Panel>
  );
}
